import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('natcas-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('natcas-language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'se' : 'en');
  };

  const t = (key, translationObj) => {
    // If translationObj is the actual translation object with language keys
    if (translationObj && typeof translationObj === 'object') {
      // Check if it has language keys directly
      if (translationObj[language] !== undefined) {
        return translationObj[language];
      }
      if (translationObj['en'] !== undefined) {
        return translationObj['en'];
      }
      // Check if it has nested key
      if (translationObj[key]) {
        const nested = translationObj[key];
        return nested[language] || nested['en'] || key;
      }
    }
    return key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
